<template>
  <v-flex v-if="canShowProps">
    <v-flex class="subheading">{{ $t('Properties') }}:</v-flex>
    <v-layout
      row
      wrap
      class="text--disabled py-3 subheading">
      <v-flex>
        <v-flex v-if="canShowOptions">
          <div>
            <span v-if="selected.classification === 'bundle'">{{ $t('Bundle Options') }}:</span>
            <span v-if="selected.classification === 'common'">{{ $t('Variant Options') }}:</span>
          </div>

          <template v-if="canShowVariations">
            <div
              v-for="(prop, index) in selected.properties"
              :key="index"
              class="ml-2"
            >
              <span class="font-weight-bold">{{ prop.name }}: </span>
              <span>{{ prop.value }}</span>
            </div>
          </template>

          <template v-if="canShowComponents">
            <div
              v-for="(comp, index) in selected.components"
              :key="index"
              class="ml-2"
            >
              <span v-if="comp.name">{{ comp.quantity }}x {{ comp.name }} </span>
            </div>
          </template>
        </v-flex>

        <v-flex v-if="canShowExtras">
          <div>
            <span>{{ $t('Extras') }}:</span>
          </div>

          <div
            v-for="extra in selected.extras"
            :key="extra.key"
            class="ml-2"
          >
            <span>{{ extra.name }}: </span>
            <span class="font-italic">{{ extra.options.map(o => o.value).join(', ') }}</span>
          </div>
        </v-flex>
      </v-flex>
    </v-layout>
  </v-flex>
</template>

<script>
export default {
  name: 'OrderDraftItemProperties',

  props: {
    selected: {
      type: Object,
      default: () => null
    }
  },

  computed: {
    canShowProps () {
      return this.selected && (this.canShowOptions || this.canShowExtras)
    },

    canShowExtras () {
      return this.selected.extras && Object.values(this.selected.extras).length
    },

    canShowComponents () {
      return this.selected.components && this.selected.components.length && this.selected.components.some(e => e.name)
    },

    canShowVariations () {
      return this.selected.parent_id && this.selected.properties && this.selected.properties.length
    },

    canShowOptions () {
      return this.canShowComponents || this.canShowVariations
    }
  }
}
</script>
